import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function ThumbsUp({ width, height, color }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.65398 1.20161L4.42232 4.43327C4.20648 4.64911 4.08398 4.94661 4.08398 5.25577V11.0833C4.08398 11.7249 4.60898 12.2499 5.25065 12.2499H10.5007C10.9673 12.2499 11.3873 11.9699 11.574 11.5441L13.4757 7.10494C13.9657 5.94994 13.1198 4.66661 11.8657 4.66661H8.56982L9.12398 1.99494C9.18232 1.70327 9.09482 1.40577 8.88482 1.19577C8.54065 0.857441 7.99232 0.857441 7.65398 1.20161ZM1.75065 12.2499C2.39232 12.2499 2.91732 11.7249 2.91732 11.0833V6.41661C2.91732 5.77494 2.39232 5.24994 1.75065 5.24994C1.10898 5.24994 0.583984 5.77494 0.583984 6.41661V11.0833C0.583984 11.7249 1.10898 12.2499 1.75065 12.2499Z'
        fill={color || theme.colors.gray500}
      />
    </svg>
  );
}
